import { Data, List, Misc, ModalUtils } from '@singularsystems/neo-core';
import { Routing, Views } from '@singularsystems/neo-react';
import { NotificationDuration } from "../../../App/Models/NotificationDuration";
import { AppService, Types } from '../../DomainTypes';
import Issuer from "../../Models/Issuers/Issuer";
import IssuerPagedLookup from "../../Models/Issuers/Lookups/IssuerPagedLookup";
import IssuerPagedLookupCriteria from "../../Models/Issuers/Lookups/IssuerPagedLookupCriteria";
import NoteVM from '../../Models/Notes/NoteVM';
import AuthorisationVM from '../../Services/AuthorisationVM';

export default class IssuerVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public dataCache = AppService.get(Types.Domain.Services.DataCache),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        private issuerApiClient = AppService.get(Types.Domain.ApiClients.Issuer),
        private issuerInvestmentCache = AppService.get(Types.Domain.Services.IssuerInvestmentCache)) {

        super(taskRunner);
        this.autoRunner = this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.pageManager.refreshData()))
        this.makeObservable();
    }

    public noteVM = this.registerViewModel(NoteVM);
    public authorisationVM = this.registerViewModel(AuthorisationVM);

    public issuerPageList = new List(IssuerPagedLookup);
    public criteria = new IssuerPagedLookupCriteria();
    public editingIssuer: Issuer | null = null;
    public autoRunner?: Misc.IAutoRunner;
    public static lastIssuer?: Issuer;

    public pageManager = new Data.PageManager(this.criteria, IssuerPagedLookup, this.issuerApiClient.getIssuerLookupsPaged, {
        pageSize: 20,
        initialTaskRunner: this.taskRunner,
        fetchInitial: false,
        allowSort: true,
        sortBy: "issuerName"
    });

    public async onIssuerParamsChanged(issuerParam: Routing.IViewParameter) {
        if (issuerParam.value) {
            if (issuerParam.value === "new") {
                this.newIssuer();
                issuerParam.description = "New Issuer";
            } else {
                await this.fetchIssuer(issuerParam.value as number);
                issuerParam.description = this.editingIssuer!.issuerName;
            }
        } else {
            this.editingIssuer = null;
        }
    }

    public newIssuer() {
        this.editingIssuer = new Issuer();
    }

    private async fetchIssuer(issuerId: number) {
        const response = await this.taskRunner.waitFor(this.issuerApiClient.getIssuer(issuerId));
        this.editingIssuer = Issuer.fromJSObject<Issuer>(response.data);
    }

    public async saveIssuer() {
        this.taskRunner.run(async () => {
            var response = await this.issuerApiClient.saveIssuer(this.editingIssuer!.toJSObject());
            this.editingIssuer!.update(response.data);
            this.pageManager.refreshData();
            this.issuerInvestmentCache.reset();
            this.notifications.addSuccess("Saved Successfully", "Issuer saved successfully.", NotificationDuration.Standard);
        });
    }

    public setIssuerPendingDelete(issuer: Issuer) {
        issuer.isPendingDelete = !issuer.isPendingDelete;
        if (issuer.isPendingDelete) {
            this.notifications.addInfo("Mark Deleted", `Please click save to action this request.`, NotificationDuration.Standard);
        }
    }
}